// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2bFlw","colMin":"styles_colMin__66B-C","colCheckbox":"styles_colCheckbox__1PVaP"};